export const errorMapping = {
  'ProjectGroup not created': 'A product with the same name already exists.',
  'ProjectGroup not updated': 'A product with the same name already exists.',
  'Project not created': 'An environment with the same name already exists.'
}
